/**
 * Use altClass on the <message altClass=''/> tag to set alternate css class
 *
 * Usage: use 'autohide' parameter to enable/disable the automatic hiding of the message bar
 * <message autohide="true|false"/>
 */
angular.module('qkr').directive('mssTimeFormat', ['utils', function(utils) {
    return {
        restrict: 'E',
        template: '{{display}}',
        scope: {
            time: '='
        },
        link(scope, elem, attrs) {
            scope.display = utils.twoDecimalPlaces(scope.time);
            return;
        }
    };
}]);



// WEBPACK FOOTER //
// ./src/directives/report/timeFormat.js